import http from './http.service';

class PersonalizationService {
    constructor() {
        // Services included in vuex components(actions, mitations etc) have to skip this.$http assignment like auth.service.js, paersonalization.service.js and lang.service.js included in actions.js
        // this.$http = http;
        this.baseUrl = "/api/personalization";
    }

    loadGridSettings(componentName) {
        if (!componentName) {
            throw new Error('Grid options is required');
        }

        return http.get(`${this.baseUrl}/${componentName}/getGridSettings`);
    };

    saveGridSettings(componentName, gridSettings) {
        if (!componentName || !gridSettings) {
            throw new Error('Grid options is required');
        }

        return http.post(`${this.baseUrl}/saveGridSettings`, {
            componentName: componentName,
            gridSettings: JSON.stringify(gridSettings)
        });
    };

    delteGridSettings(componentName) {
        if (!componentName) {
            throw new Error('Component name is required');
        }

        return http.delete(`${this.baseUrl}/deleteGridSettings`, { params: { componentName: componentName } });
    };

    claerState(componentName) {
        try {
            localStorage.removeItem('' + componentName + "-grid-state");
        } catch (e) {

        }
    }

    saveState(componentName, gridSettings) {
        if (!componentName || !gridSettings) {
            return;
        }

        try {
            if (!gridSettings.hasOwnProperty("dataSource")) {
                return;
            }

            let ds = gridSettings.dataSource;
            if (ds.filter || ds.sort || ds.aggregate || ds.page > 1) {
                localStorage.removeItem('' + componentName + "-grid-state");

                var gridState = {
                    filter: ds.filter,
                    sort: ds.sort,
                    aggregate: ds.aggregate,
                    page: ds.page
                }

                localStorage['' + componentName + "-grid-state"] = kendo.stringify(gridState);
            }
        } catch (e) {}
    }

    getState(componentName) {
        if (!componentName) {
            return null;
        }

        try {
            let gridState = localStorage['' + componentName + "-grid-state"];
            if (!gridState) {
                return null;
            }

            let result = JSON.parse(gridState)
            return result;
        } catch (e) {
            return null
        }
    }

    mergeStateSettings(gridSettings, stateSettings) {
        if (!gridSettings || !stateSettings) {
            return null;
        }

        try {
            if (!gridSettings.hasOwnProperty("dataSource")) {
                return null;
            }

            if (stateSettings.filter) {
                gridSettings.dataSource.filter = stateSettings.filter;
            }

            if (stateSettings.sort) {
                gridSettings.dataSource.sort = stateSettings.sort;
            }

            if (stateSettings.aggregate) {
                gridSettings.dataSource.aggregate = stateSettings.aggregate;
            }

            if (stateSettings.page) {
                gridSettings.dataSource.page = stateSettings.page;
            }
        } catch (e) {
            return null;
        }

        return gridSettings;
    }

    mergePersonGridSettings(gridSettings, loadedSettings) {
        if (!gridSettings || !loadedSettings) {
            return null;
        }

        let options = JSON.parse(loadedSettings);
        if (!options || !options.hasOwnProperty("columns")) {
            return null;
        }

        options.loadedUserSettings = true;

        if (options.hasOwnProperty("dataSource") && gridSettings.hasOwnProperty("dataSource")) {
            options.dataSource = gridSettings.dataSource;
        }

        let btnsColumn = gridSettings.columns.find(col => col.field === "btnsColumn");
        if (btnsColumn && btnsColumn.template) {
            for (var i = 0; i < options.columns.length; i++) {
                let col = options.columns[i];
                if (col.hasOwnProperty("field") && col.field === "btnsColumn") {
                    options.columns[i].template = btnsColumn.template;
                    break;
                }
            }
        }

        if (gridSettings.columns && Array.isArray(gridSettings.columns) && options.columns && Array.isArray(options.columns)) {
            gridSettings.columns.forEach((origColumn) => {
                const targetColumn = options.columns.find(c => c.field && origColumn.field && c.field === origColumn.field);
                if (targetColumn && !!targetColumn.template === false && !!origColumn.template === true) {
                    targetColumn.template = origColumn.template;
                }
            })
        }

        return options;
    }

    clearFilters(grid) {
        if (grid) {
            grid.dataSource.sort({});
            grid.dataSource.page(1);
            grid.dataSource.aggregate([]);
            grid.dataSource.filter({});
        }
    }

    loadEventsListUserSettings() {
        return http.get(`${this.baseUrl}/loadEventsListUserSettings`);
    };

    saveEventsListUserSettings(model) {
        return http.post(`${this.baseUrl}/saveEventsListUserSettings`, model);
    };

    loadSchedulerCalendarUserSettings() {
        return http.get(`${this.baseUrl}/loadSchedulerCalendarUserSettings`);
    };

    saveSchedulerCalendarUserSettings(model) {
        return http.post(`${this.baseUrl}/saveSchedulerCalendarUserSettings`, model);
    };

    loadReleaseInfo() {
        return http.get(`${this.baseUrl}/loadReleaseInfo`);
    }

    saveReleaseInfo(info) {
        return http.post(`${this.baseUrl}/saveReleaseInfo`, { info: info });
    }

    loadUserSettings(userId) {
        if (!userId) {
            throw new Error('UserId name is required');
        }

        return http.get(`${this.baseUrl}/loadDynamicLayoutSettings`, { params: { userId: userId } });
    }

    saveDynamicLayoutSettings(model) {
        if (!model) {
            throw new Error('Model name is required');
        }

        return http.post(`${this.baseUrl}/saveDynamicLayoutSettings`, model);
    }

    loadAppSigningSettings() {
        return http.get(`${this.baseUrl}/loadAppSigningSettings`);
    }
}

export default new PersonalizationService();
